export default __webpack_public_path__ + "static/gabrielcheang1-b5062418f42ae25c40322fcf0fd990d1.jpg";